import { render, staticRenderFns } from "./ImgsEdit.vue?vue&type=template&id=4569ac90&"
import script from "./ImgsEdit.vue?vue&type=script&lang=js&"
export * from "./ImgsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports